var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgClose3 = function SvgClose3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.443 2.557c.238.237.283.578-.43 1.29L6.86 6l2.152 2.152c.713.713.668 1.054.43 1.291-.237.238-.578.283-1.29-.43L6 6.86 3.848 9.013c-.713.713-1.054.668-1.291.43-.238-.237-.283-.578.43-1.29L5.14 6 2.987 3.848c-.713-.713-.668-1.054-.43-1.291.237-.238.578-.283 1.29.43L6 5.14l2.152-2.152c.713-.713 1.054-.668 1.291-.43z",
    fill: "#020814"
  })));
};
export default SvgClose3;